import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "back",
  style: {"padding":"0 12px 0 16px"},
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 구매 신청 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 주당 가격 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 구매 금액 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 수량 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 약 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 거래 수수료 1% ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 예수금 차감 예정 금액 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 구매 취소 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 구매 신청 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!
  const _component_ag_content = _resolveComponent("ag-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          dp: "flex",
          "align-items": "center",
          p: "3px 0px 20px 0px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, {
              class: "ion-activatable ripple-parent",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _: 1
            }),
            _createVNode(_component_ag_text, {
              typography: "tit18b",
              color: "black"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ag_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box_s, { css: {
        dp:'flex',
        direction:'column',
        justifyContent:'space-between',
        height:'100%',
        px:'20px',
      } }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box_s, { css: {
          dp:'flex',
          direction:'column',
          alignItems:'center',
          justifyContent:'center',
          height:'200px',
        } }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_img, {
                  width: "40px",
                  height: "40px",
                  src: _ctx.dealInfo.partnershipLogo
                }, null, 8, ["src"]),
                _createVNode(_component_ag_text_s, { css: {
            pt:8,
            typography:'tit16b'
          } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.dealInfo.partnershipName) + " 조합원 자격 ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ag_box_s),
            _createVNode(_component_ag_box_s, null, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box_s, { css: {typography:'tit20r', mb:'24px'} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {typography:'text14r', color:'gray3'} }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box_s, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {typography:'num20eb'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.expectedPurchaseInfo.price)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {typography:'tit20r', mb:'24px'} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {typography:'text14r', color:'gray3'} }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box_s, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {typography:'num20eb'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.expectedPurchaseInfo.totalPrice)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {typography:'tit20r', mb:'24px'} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {typography:'text14r', color:'gray3'} }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box_s, null, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createVNode(_component_ag_text_s, { css: {typography:'num20eb'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.expectedPurchaseInfo.qty)), 1)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" 주 (" + _toDisplayString(_ctx.$filters.currency(_ctx.expectedPurchaseInfo.asset)) + "좌) ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {typography:'tit20r', mb:'24px'} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {typography:'text14r', color:'gray3'} }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box_s, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {typography:'num20eb'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.expectedPurchaseInfo.fee)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {height:1, width:'100%', bg:'#f9f9fb', mb:24} }),
                _createVNode(_component_ag_box_s, { css: {typography:'tit24r', mb:'24px', dp:'flex', direction:'row', justifyContent: 'space-between'} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {typography:'tit16b'} }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box_s, { css: {color:'primary'} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {typography:'num24eb'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.expectedPurchaseInfo.depositAmount)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ag_footer, {
          p: "20px",
          mb: "safeAreaBottom"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, {
              dp: "flex",
              gap: "sp6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_button, {
                  block: "lg",
                  corner: "10px",
                  outline: "primary",
                  height: "100%",
                  width: "100%",
                  onClickCapture: _ctx.cancelToBuy
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["onClickCapture"]),
                _createVNode(_component_ag_button, {
                  block: "lg",
                  corner: "10px",
                  width: "100%",
                  onClickCapture: _ctx.requestToBuy
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["onClickCapture"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}